export const getTableConfig = () => {
  // table 通用属性
  const common = {
    isSelection: false,
    loading: false,
    stripe: true,
    size: 'small',
    isIndex: false,
    indexLabel: '序号',
    data: []
  }

  // table 分页
  const pagination = {
    isShow: true,
    total: 0,
    pageSize: 20,
    currentPage: 1,
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'companyName',
      label: '企业名称',
      width: '160'
    },
    {
      key: 'appId',
      label: '企业appid',
      width: '180'
    },
    {
      key: 'aesKey',
      label: '客户密钥（aesKey）',
      width: '180'
    },
    {
      key: 'signKey',
      label: '签名密钥（signKey）',
      width: '180'
    },
    {
      key: 'notifyUrl',
      label: '回调地址',
      width: '280'
    },
    {
      key: 'modules',
      label: '选用模块',
      width: '200',
      slot: 'modulesText'
    },
    {
      key: 'statusText',
      label: '状态',
      width: '60'
    },
    {
      key: 'action',
      label: '操作',
      width: '120',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

import { enumToOption } from '@/utils'

// 选用模块
export enum moduleType {
  '扫码登录' = 1,
  '违章转移',
  '违章信息推送',
  '查询违章'
}

// 状态
export enum state {
  启用 = 1,
  禁用
}

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 搜索变量
  const inputList = [
    {
      type: 'input',
      label: '企业名称',
      key: 'companyName',
      placeholder: '请输入',
      labelWidth: 100,
      inputWidth: 200,
      maxlength: 50,
      rules: {}
    },
    {
      type: 'select',
      label: '状态',
      key: 'status',
      placeholder: '请选择',
      labelWidth: 100,
      inputWidth: 200,
      options: enumToOption(state),
      rules: {
        type: 'number'
      }
    }
  ]

  // 页面基础变量
  const page = {
    queryForm: {}, // 搜索参数
    visible: false, // 弹框显示
    rowData: null // 单行数据
  }

  return {
    inputList,
    ...page
  }
}
